<script setup lang="ts">
import { ChartBarBig } from 'lucide-vue-next'
</script>

<template>
  <NuxtLinkLocale
    to="/banks/statistics"
    data-testid="banking-stats-cta"
    class="relative block overflow-hidden rounded-lg bg-gradient-to-br from-[#1E3A8A] to-[#3B82F6] p-4 text-white transition-all duration-500 ease-out hover:from-[#1D4ED8] hover:to-[#60A5FA]"
  >
    <NuxtImg
      src="/images/photostock/guy-increases-his-capital-592x592.avif"
      alt=""
      class="absolute bottom-[-20px] right-[-10px] z-0 object-contain transition-opacity duration-300 sm:bottom-[-5px]"
      width="150"
      height="150"
      format="avif,webp"
      quality="85"
      loading="lazy"
    />
    <div class="relative z-10">
      <div class="mb-3 sm:hidden">
        <NuxtImg src="/images-backup/logos/logo-white.png" alt="Logo" width="70" height="26" />
      </div>

      <NuxtImg
        src="/images-backup/logos/logo-white.png"
        alt="Logo"
        class="mb-3 hidden sm:block"
        width="86"
        height="32"
      />

      <h3
        class="z-10 max-w-40 text-base font-bold leading-tight sm:mb-2 sm:max-w-full sm:text-xl xl:max-w-52"
      >
        {{ $t('widget.banking_statistics.cta.title') }}
      </h3>

      <p class="mb-4 hidden max-w-44 text-sm leading-snug text-white/90 sm:block">
        {{ $t('widget.banking_statistics.cta.text') }}
      </p>

      <div class="mb-4 hidden items-center gap-2 sm:flex">
        <div class="flex h-5 w-5 items-center justify-center rounded-full bg-white">
          <ChartBarBig class="size-3.5 text-[#1E3A8A]" />
        </div>
        <span class="text-sm font-bold">{{ $t('widget.banking_statistics.cta.cta') }}</span>
      </div>
    </div>
  </NuxtLinkLocale>
</template>
